import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APP } from './app.config';

@Injectable({
  providedIn: 'root',
})
export class RecoveryCodeService {
  constructor(private http: HttpClient) {}

  /**
   * Generate a new recovery code
   * @param userId - optional for anonymous users, omitted for authenticated users
   */
  generateRecoveryCode(userId?: string): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    const body: any = {};
    if (userId) {
      body.userId = userId;
    }

    return this.http
      .post(APP.baseurl + '/user-id/recovery-code', body, httpOptions)
      .toPromise();
  }

  /**
   * Validate a recovery code
   * @param recoveryCode - the code to validate
   */
  validateRecoveryCode(recoveryCode: string): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .get(
        APP.baseurl + '/user-id/recovery-code/' + recoveryCode,
        httpOptions
      )
      .toPromise();
  }

  /**
   * Regenerate a recovery code (in case of compromise)
   */
  regenerateRecoveryCode(): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .post(APP.baseurl + '/user-id/recovery-code/regenerate', {}, httpOptions)
      .toPromise();
  }
}
